import styled from "styled-components/macro";

export default function SharedBy({ fname, photoURL, userID }) {
  return (
    <Wrapper>
      <UserPhoto style={photoURL && { backgroundImage: `url(${photoURL})` }} />
      Shared by {fname}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  border-radius: 24px;
  font-size: 14px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  width: fit-content;
  background: rgba(255, 255, 255, 0.3);
  padding: 2px;
  padding-right: 8px;
  position: absolute;
  top: 0px;
  left: 0px;
  .card_type_amex & {
    background: rgba(0, 0, 0, 0.4);
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    padding-right: 6px;
  }
`;

const UserPhoto = styled.div`
  background-image: url(https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg);
  background-size: cover;
  background-position: center center;
  border-radius: 40px;
  width: 22px;
  height: 22px;
  margin-right: 4px;
`;
